import { isIOS } from './deviceDetection.js'

export function openExternalLink(url: string): void {
  // iOS popup blockers are stricter, so open immediately from the gesture context.
  if (isIOS()) {
    const popup = window.open('', '_blank', 'noopener,noreferrer')
    if (popup) {
      popup.opener = null
      popup.location.href = url
      return
    }
  }

  const popup = window.open(url, '_blank', 'noopener,noreferrer')
  if (!popup) {
    window.location.href = url
  }
}
